/* eslint-disable */

import "babel-polyfill";

import conf from "./configs/index";
import Vue from "vue";
import App from "./App";
import router from "./routes";

import axios from "axios";
import lodash from "lodash";
import iView from "./utils/iview";
import ElLoading from "element-loading";
import store from "./stores";
import components from "./components";
import mixins from "./mixins";
import api from "./utils/api";
import filter from "./utils/filter";
import Viewer from  "./utils/viewer";
import rbac from "@i-components/i-rbac"
import RichSearchInput from "@i-components/i-rich-search-input"
import AdmPanel from "@i-components/i-adm-panel"
import "@i-components/i-adm-panel/dist/i-adm-panel.css"
import "@i-components/i-rich-search-input/dist/i-rich-search-input.css"
import FilterBar from "@i-components/i-filter-bar";

import PDFViewer from "@/plugins/pdf-viewer"

import OperationLog from "@/components/plugin/OperationLog/"
import LoginModal from "@/components/plugin/LoginModal/"

PDFViewer(Vue)

Vue.use(Viewer);
Vue.use(iView);
Vue.use(ElLoading);
// Vue.use(echart);
mixins(Vue);
components(Vue);
filter(Vue);
//isMobile() ? eruda.init() : null;
Vue.use(RichSearchInput({prefix:"iv-",debug:true}));
Vue.use(AdmPanel({prefix:"iv-"}));
Vue.use(FilterBar({prefix:"iv-"}))

Vue.use(OperationLog())
Vue.use(LoginModal())

axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$lodash = Vue.prototype._ = lodash;
Vue.prototype.$api = api;

Vue.config.productionTip = false;

//注册用户行为权限控制的插件，由于需要用到vuex的store需要在设置了store后再投入使用
Vue.use(rbac({
  allow(store, data, el){ //判断是否允许的函数
    const type = [d=>d instanceof Array, d=>typeof d==='string'].findIndex(fun=>fun(data))
    const permission = store.state.account.authorization.permission
    let allow = false;
    switch(type){
      case 0:
        const [resource, action] = data
        allow = permission[resource] ? permission[resource].indexOf(action)>-1 : false
        break;
      case 1:
        allow = permission.hasOwnProperty(data)
        break;
    }
    return allow
  }
}));

if (!!window) {
  window.system = {
    [conf.name]: {
      version: conf.version,
      buildAt: conf.buildAt
    }
  };
}

new Vue({
    render: h => h(App),
    router,
    store
}).$mount("#app");
